import { type ReactElement, useState } from 'react';
import { ServicesSubcriptionsDependencies} from '../components/services/servicesSubcriptionsDependencies.tsx'


export function ServicesPage(): ReactElement {

  return <ServicesSubcriptionsDependencies />
}